import axios from 'axios';

export default class Job {
  constructor() {
    this.board_token = 'luminary';
    this.api_url = `https://boards-api.greenhouse.io/v1/boards/${this.board_token}/`;
  }

  getJobsByDepartment() {
    return new Promise((resolve, reject) => {
      const endpoint = `${this.api_url}departments`;
      const config = {
        public: true,
      };
      axios.get(endpoint, config).then((resp) => {
        resolve(resp.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getJobDetail(jobId) {
    return new Promise((resolve, reject) => {
      const endpoint = `${this.api_url}jobs/${jobId}`;
      const config = {
        public: true,
      };
      axios.get(endpoint, config).then((resp) => {
        resolve(resp.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./app/src/services/Job.js